import React__default, { useState, useEffect } from 'react';
import { connectStateResults } from 'react-instantsearch-core';
import { Tabs, Tab } from '@grandvisionhq/common';
import { useIntl } from '@grandvisionhq/state';
import { getResultsByIndex } from '../../Algolia/utils/get-results-by-index.js';

function lowercaseAndCapitalize(str) {
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
}
const SearchTabs = ({ allSearchResults , setActiveTabIndex , activeTabIndex , indexes , productIndex  })=>{
    const { getLabel  } = useIntl();
    const productSuggestions = getResultsByIndex(allSearchResults, productIndex.name);
    const contentSuggestions = indexes.contentIndex && getResultsByIndex(allSearchResults, indexes.contentIndex.name);
    const productLabel = lowercaseAndCapitalize(getLabel('search.suggestions.products.title'));
    const contentLabel = lowercaseAndCapitalize(getLabel('search.suggestions.content.title'));
    var ref;
    // fix for getting non faceted content results
    const [contentHits, setContentHits] = useState((ref = contentSuggestions === null || contentSuggestions === void 0 ? void 0 : contentSuggestions.nbHits) !== null && ref !== void 0 ? ref : 0);
    useEffect(()=>{
        if ((contentSuggestions === null || contentSuggestions === void 0 ? void 0 : contentSuggestions.nbHits) > 0) setContentHits(contentSuggestions === null || contentSuggestions === void 0 ? void 0 : contentSuggestions.nbHits);
    }, [
        contentSuggestions
    ]);
    var ref1;
    return /*#__PURE__*/ React__default.createElement(Tabs, {
        onChange: setActiveTabIndex,
        activeTabIndex: activeTabIndex
    }, /*#__PURE__*/ React__default.createElement(Tab, {
        label: `${productLabel} (${(ref1 = productSuggestions === null || productSuggestions === void 0 ? void 0 : productSuggestions.nbHits) !== null && ref1 !== void 0 ? ref1 : 0})`
    }), /*#__PURE__*/ React__default.createElement(Tab, {
        label: `${contentLabel} (${contentHits})`
    }));
};
var SearchTabs$1 = connectStateResults(SearchTabs);

export { SearchTabs, SearchTabs$1 as default };
//# sourceMappingURL=SearchTabs.js.map
